import { type Ref, useState } from 'react'

import type { TypeaheadHandle } from '@fv/client-components/combobox'
import { useDebouncedValue } from '@fv/client-core'
import type { CarrierDTO } from '@fv/models/admin'

import { AdminTypeaheadField } from '@/components/AdminTypeaheadField'

import { useSearchCarriers } from '../queries'
import { CarrierBadge } from './CarrierBadges'

type Props = {
  ref?: Ref<TypeaheadHandle>
  carrier?: CarrierDTO
  name: string
  onCarrierChange?: (value: CarrierDTO | null) => void
}

export const CarrierTypeAhead = ({
  ref,
  carrier,
  name,
  onCarrierChange,
}: Props) => {
  const [searchText, setSearch] = useState(carrier?.name || '')
  const debouncedSearch = useDebouncedValue(searchText, 500)
  const carriersQuery = useSearchCarriers(debouncedSearch)
  const carriers = carriersQuery.data?.pages?.at(0)?.data || []

  return (
    <AdminTypeaheadField
      ref={ref}
      name={name}
      options={carriers}
      getOptionLabel={c => c.name}
      value={carrier}
      onChange={onCarrierChange}
      onSearchChange={setSearch}
      isClearable
      filter={null}
      isLoading={carriersQuery.isFetching}
      getOptionValue={c => c._id}
      placeholder="Carrier"
      renderOption={v => (
        <div className="flex flex-col leading-tight">
          <div>
            {v.name} <CarrierBadge carrier={v} className="badge-xs" />
          </div>

          <small>{v._id}</small>
        </div>
      )}
    />
  )
}
